var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-secondary text-light deck-download",on:{"click":_vm.onDownloadDeck}},[_c('DownloadIcon'),_vm._v(" Download\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }